export const updateOthersNotesDetails = (agendaItem, payload, actionOptions) => {
  const { agendaItemOthersNotesDetails, agendaItemNoteId } = payload;
  const existingOthersNotes = agendaItem.agendaItemOthersNotesDetails || [];
  const newNoteData = agendaItemOthersNotesDetails && agendaItemOthersNotesDetails[0];
  if (actionOptions.deleteNote) {
    deleteNoteData(existingOthersNotes, agendaItemNoteId);
  }
  else if (newNoteData) {
    addOrUpdateNoteData(existingOthersNotes, newNoteData);
  }

  agendaItem.agendaItemOthersNotesDetails = existingOthersNotes;
};

const addOrUpdateNoteData = (existingOthersNotes, newNoteData) => {
  const existingNoteIndex = existingOthersNotes.findIndex(note => note.id === newNoteData.id);

  if (existingNoteIndex !== -1) {
    existingOthersNotes[existingNoteIndex] = { ...existingOthersNotes[existingNoteIndex], ...newNoteData };
  } else {
    existingOthersNotes.push(newNoteData);
  }
};

const deleteNoteData = (existingOthersNotes, agendaItemNoteId) => {
  const existingNoteIndex = existingOthersNotes.findIndex(note => note.id === agendaItemNoteId);

  if (existingNoteIndex !== -1) {
    existingOthersNotes.splice(existingNoteIndex, 1);
  }
};